import React from 'react';
import { Paper, Stack } from '@mui/material';
import { InteractiveImage } from './InteractiveImage';

interface LeftPanelProps {
  originalImageUrl: string;
  processedImageUrl: string;
  onRetake: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const LeftPanel: React.FC<LeftPanelProps> = ({ originalImageUrl, processedImageUrl, onRetake }) => {
  return (
    <Paper sx={{ p: 2, height: '100%', overflowY: 'auto', boxSizing: 'border-box' }} variant="outlined">
      <Stack spacing={2} sx={{ height: '100%' }}>
        <InteractiveImage
          title="Uploaded Image"
          imageUrl={originalImageUrl}
          showRetake={true}
          onRetake={onRetake}
        />
        <InteractiveImage
          title="Processed Image"
          imageUrl={processedImageUrl}
        />
      </Stack>
    </Paper>
  );
};